<template>
  <ReactPage>
    <stream-config-page></stream-config-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "StreamConfig",
  components: {
    ReactPage
  }
}
</script>